import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { reExportedColors } from './index'
import defaultLoader from './Icons/proximityLoading.gif'
import { getAppIcon } from '../../common/dynamicCustomizationService'

const defaultSettings = {
  image: { height: '100px' },
  circle: { top: '-45px', left: '-45px', size: 180 }
}

const loader = getAppIcon() || defaultLoader

const ResizableLoader = ({ image, circle }) => {
  const imageHeight = image?.height || defaultSettings.image.height
  const circleTop = circle?.top || defaultSettings.circle.top
  const circleLeft = circle?.left || defaultSettings.circle.left
  const circleSize = circle?.size || defaultSettings.circle.size

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        width: '100%'
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <Box component='img' alt='Loading' src={loader} sx={{ height: imageHeight }} />
        <CircularProgress
          size={circleSize}
          thickness={2}
          variant='indeterminate'
          sx={{
            color: reExportedColors.PROXIMITY_RED,
            left: circleLeft,
            position: 'absolute',
            top: circleTop
          }}
        />
      </Box>
    </Box>
  )
}

export default ResizableLoader
